import { RootState } from "@/store/store";
import { resourceExplorerViewDataByIdSelector } from "@/store/resource-explorer/selectors/resource-explorer-by-id/resourceExplorerViewDataByIdSelector";
import { resourceExplorerViewBudgetsSelector } from "@/store/resource-explorer/selectors/budget/resourceExplorerViewBudgetsSelector";
import { resourceExplorerViewCurrentBudgetSelector } from "@/store/resource-explorer/selectors/budget/resourceExplorerViewCurrentBudgetSelector";
import { billingExplorerDefaultChartSettings } from "@/components/pages/resource-explorer/components/resource-explorer-card/utils/constants/common";

export const billingExplorerChartSettingsSelectedBudgetChangedSelector = (
  state: RootState,
  id: string,
) => {
  const initialReport = resourceExplorerViewDataByIdSelector(state, id);
  const budgets = resourceExplorerViewBudgetsSelector(state);
  const currentBudgetId = resourceExplorerViewCurrentBudgetSelector(state)?.id;

  const initialChartSettings = initialReport?.is_default
    ? billingExplorerDefaultChartSettings
    : initialReport?.chart_settings;

  // 1. All Resources report case
  if (initialReport?.is_default) {
    return false;
  }

  // 2. Report don't have budgets
  if (!budgets) {
    return false;
  }

  // 3. No saved budget in back-end
  if (!initialChartSettings?.selected_budget_id) {
    return currentBudgetId !== budgets?.at(0)?.id;
  }

  // 4. Selected budget is deleted
  if (
    !budgets.find(
      (budget) => budget.id === initialChartSettings.selected_budget_id,
    )
  ) {
    return currentBudgetId !== budgets.at(0)?.id;
  }

  // 5. Back-end has saved budget
  return currentBudgetId !== initialChartSettings.selected_budget_id;
};
